const atomic = require('../../../git_modules/@tomandco/atomic/config');

/**
 * Component sizes to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 */
const gridSize = [];
const columns = atomic.config.grid.columns.default;
for (let i = 1; i <= columns; i++) {
    if (columns % i === 0) {
        gridSize.push({
            key: `c-${i}-set`,
            title: i
        });
    }
}
exports.gridSize = gridSize;

const itemsInRow = [];
for (let i = 1; i <= columns; i++) {
    if (columns % i === 0) {
        // items in row
        const items = columns / i;

        itemsInRow.push({
            key: `c-${i}-set`,
            title: items
        });
    }
}
exports.itemsInRow = itemsInRow;
